<template>
  <div class="list-group mt-2">
    <div
      :class="`disable-cursor list-group-item list-group-item-action ${hover === item.processo ? 'active' : ''}`"
      v-for="item in items"
      :key="item.processo"
      @mouseover="hover = item.processo" @mouseleave="hover = ''"
    >
      <body-protocolo :hover="hover === item.processo" :data="item"/>
    </div>
    <div class="mt-2">
      <pagination-comp :pagination="pagination" :eventBusDataPaginationName="eventBusDataPaginationName"/>
    </div>
  </div>
</template>

<script>
import paginationComp from '@/components/pagination/Pagination'
import bodyProtocolo from '@/components/buscaGeral/list/body'
import eventBus from '@/uteis/eventBus'

export default {
  components: {
    paginationComp,
    bodyProtocolo
  },

  props: {
    eventBusDataName: { required: true, type: String },
    eventBusDataPaginationName: { required: true, type: String }
  },

  methods: {
    popularTable (values) {
      this.pagination = values.pagination
      this.items = values.data
    },

    async waitString (string) {
      return string
    }
  },

  created () {
    eventBus.$on(this.eventBusDataName, (values) => {
      this.popularTable(values)
    })
  },

  data () {
    return {
      hover: '',
      dataTableChecked: [],
      items: [],
      column: [],
      pagination: {
        hasPrev: false,
        hasNext: false,
        totalPage: 0
      }
    }
  }
}
</script>
